import { render, staticRenderFns } from "./ForeplayLogoSidebarIcon.vue?vue&type=template&id=5fe72068&scoped=true"
import script from "./ForeplayLogoSidebarIcon.vue?vue&type=script&lang=js"
export * from "./ForeplayLogoSidebarIcon.vue?vue&type=script&lang=js"
import style0 from "./ForeplayLogoSidebarIcon.vue?vue&type=style&index=0&id=5fe72068&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe72068",
  null
  
)

export default component.exports